import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetLocationClusterGroupsParams } from './types'
import type { ClusterGroupsDto } from './dtos'

const URL = '/location/cluster-groups/'

export const getClusterGroups: AblePaginatedResponseFn<
GetLocationClusterGroupsParams,
ClusterGroupsDto
> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
